import React from 'react'
import { AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai'
import { CiTrash } from 'react-icons/ci'
import FormatCurrency from '../../helpers/FormatCurrency'
import { displayImage } from '../../helpers/config'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '../../helpers/Axios'

function CartItem({ item = {} }) {

    const queryClients = useQueryClient()


    // Change Quantity

    const { mutate: change } = useMutation({
        mutationFn: async (formData) => {
            return apiClient.post('/cart/change', formData)
        },
        onSuccess: () => {
            queryClients.invalidateQueries(['cart'])
        }
    })

    const handleQuantityChangle = (id, target) => {
        change({ id, target })
    }



    // Delete Item
    const { mutate: deleteItem } = useMutation({
        mutationFn: async (id) => {
            return apiClient.delete('/cart/delete', { params: { id: id } })
        },
        onSuccess: () => {
            queryClients.invalidateQueries(['cart'])
        }
    })

    const handleDelete = (id) => {
        deleteItem(id)
    }


    return (
        <div className="flex gap-5 pb-4 border-b">
            {/* img */}
            <div>
                <img src={displayImage(JSON.parse(item?.product?.images)[0])} alt="" className='w-36 sm:w-44' />
            </div>

            {/* Details */}
            <div className="w-full relative">
                <h2 className='font-medium'>{item?.product?.name}</h2>
                <p className="text-gray-500 text-sm"><FormatCurrency amount={item?.price - item?.discount} /></p>
                <p className="text-gray-500 text-sm capitalize">
                    {item?.variant?.size} {item?.variant?.color}
                </p>
                {/* Customise */}
                {item?.product?.customable && (
                    <p className="text-gray-500 text-sm capitalize flex gap-1">
                        Customisation: <FormatCurrency amount={item?.customisation_price * item?.quantity} />
                    </p>
                )}
                {/* Quantity */}
                <div className="w-24 rounded mt-2 p-2.5 py-1 bg-gray-100 border flex items-center justify-between">
                    <button onClick={() => handleQuantityChangle(item?.id, 'minus')}><AiOutlineMinus size={11} /></button>
                    <input type="text" value={item?.quantity} disabled onChange={() => { }}
                        className='outline-none text-sm bg-transparent w-5 text-center'
                    />
                    <button onClick={() => handleQuantityChangle(item?.id, 'plus')}><AiOutlinePlus size={11} /></button>
                </div>
                <p className="text-slate-800 mt-2 text-sm font-semibold">
                    <FormatCurrency amount={item?.line_total} />
                </p>

                {/*Delete Trash  */}
                <button onClick={() => handleDelete(item?.id)} className='absolute top-0 right-0 text-red-700'>
                    <CiTrash />
                </button>
            </div>
        </div>
    )
}

export default CartItem